module.exports = __webpack_public_path__ + "static/media/efs_minsk_map.58f2a008.jpg";